import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import FinancialOnboardingDescription from '../../../../components/FormDescriptions/FinancialOnboardingDescription';
import { emptyObjectSchema } from '../../../../definitions';
import content from '../../../../locales/en/content.json';

export default {
  uiSchema: {
    ...titleUI(content['household-info--financial-onboarding-title']),
    ...descriptionUI(FinancialOnboardingDescription),
  },
  schema: emptyObjectSchema,
};
